import { FieldValues, createFormControl, useFormContext, useFormState } from "react-hook-form";

const detachedControl = createFormControl<FieldValues>().control;

export const useHasUnsavedFields = () => {
  const form = useFormContext();
  const { dirtyFields } = useFormState({ control: form?.control ?? detachedControl });
  return Object.keys(dirtyFields).length > 0;
};
